module.exports = __webpack_public_path__ + "img/paymentTerms.baa726bf.png";